<template>
    <div class="modal fade" id="modalDeleteEvento" tabindex="-1" 
      role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="eventoSeleccionadoEliminar">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Cancelación del Evento </h5>
            <button type="button" class="btn btn-danger" @click="closeEliminarEvento()"><i class="fas fa-times"></i></button>
          </div>
          <hr>
          <div class="row mx-4 mt-4">
            <div class="col-6 text-left">
              <h6 class="font-weight-bold">
                {{ tipoEvento[eventoSeleccionadoEliminar.tipo] || eventoSeleccionadoEliminar.tipo }}
              </h6>
            </div>
            <div class="col-6 text-right">
              <h6 class="font-weight-bold text-dark">
                ID - {{ eventoSeleccionadoEliminar.id.toLocaleString("en-GB") }}
              </h6>
            </div>
            <div class="mt-2 mx-2">
              <p class="">
                {{ 
                  eventoSeleccionadoEliminar.proveedor + " - " + eventoSeleccionadoEliminar.proveedor_obj.nombre
                }}
              </p>
              
              <p class="" style="margin-top: -15px">
                  {{ eventoSeleccionadoEliminar.fecha_de | moment("DD-MM-YYYY") }}
                  &nbsp;/&nbsp;
                  {{ 
                    eventoSeleccionadoEliminar.fecha_de | moment("hh:mm a") 
                  }} 
                    - 
                  {{
                    eventoSeleccionadoEliminar.fecha_a | moment("hh:mm a") 
                  }}
              </p>
            </div>
          </div>
          <hr>
          <div class="row mx-2 mt-4">
            <div class="col-12 text-center">
              <h5 class="font-weight-bold">
                Razón de la cancelación
              </h5>
            </div>
            <div class="my-2 col-12">
              <div class="text-center col-12">
                <div class="row d-flex justify-content-center my-3">
                  <div class="col-12 input-group-lg">
                    <select class="form-control" v-model="selectedCancelacion" @change="isSelected = true">
                      <option value="" disabled selected>- Seleccione Razón -</option>
                      <option v-for="(item, index) in tipoCancelacion" :key="index" :value="item.llave">
                        {{ item.valor }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mx-0">
            <div class="col-12 mb-3">
              <div class="modal-footer">
                <button :disabled="!isSelected" @click="cancelarEvento(eventoSeleccionadoEliminar)" class="btn btn-md btn-danger btn-block">
                  Cancelar
                </button>
                <button @click="closeEliminarEvento()" type="button" class="btn btn-secondary">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  inject: {
    refreshAgenda: {
      from: 'refreshAgenda',
      default: () => {}
    },
  },
  mounted() {
  },
  props: {
    tipoCancelacion: {
      type: Array
    },
    tipoEvento: {
      type: Object,
    },
    eventoSeleccionadoEliminar: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isSelected: false,
      selectedCancelacion: ""
    }
  },
  methods: {
    /**
     * Método que Dispara el cierre y apertura de los modales.
     */
    closeEliminarEvento() {
      let self = this;
      self.selectedCancelacion = "";
      self.isSelected = false;
      $("#modalDeleteEvento").modal("hide");
    },

    /**
     * Método que nos permitre cancelar el evento pasado
     * en base a una razón de cancelacion.
     */
     cancelarEvento(det) {
      let self = this;      
      Notifications.alert.confirm(
        "Cancelar Evento",
        "¿Desea cancelar el evento planificado?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "agenda-proveedores",
            det.id,
            "cancelar_agenda",
            {
              motivo_cancelacion: self.selectedCancelacion,
            }
          ).then((response) => {
            self.$toast.success(response.data.detail,"Éxito",{position: 'topRight'});
            self.refreshAgenda();
            self.selectedCancelacion = "";
            self.isSelected = false;
            $("#modalDeleteEvento").modal("hide");
          });
        }
      );
    },

  }
}
</script>
